import { StatusConfigKey, StatusConfig } from '../../../types/dsn.types';
import { DateFormatType } from '../types/dsntable.types';

export const PAGE_SIZE_OPTIONS = [
  { id: '5', name: 5 },
  { id: '10', name: 10 },
  { id: '20', name: 20 },
  { id: '50', name: 50 },
];

export const DEFAULT_DATE_OPTIONS = {
  type: DateFormatType.DATE,
};

export const DEFAULT_DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

export const DATETIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  ...DEFAULT_DATE_FORMAT_OPTIONS,
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
};

export const STATUS_CONFIG: Record<StatusConfigKey, StatusConfig> = {
  StatusReceipts: {
    icon: 'download',
    color: 'var(--colorsSemanticInfo500)',
    label: 'Reçus',
    pillVariant: 'blue',
  },
  StatusAccepted: {
    icon: 'tick',
    color: 'var(--colorsSemanticPositive500)',
    label: 'Accepté',
    pillVariant: 'green',
  },
  StatusInTreatment: {
    icon: 'refresh',
    color: 'var(--colorsSemanticCaution500)',
    label: 'En traitement',
    pillVariant: 'orange',
  },
  StatusError: {
    icon: 'error',
    color: 'var(--colorsSemanticNegative500)',
    label: 'Erreur',
    pillVariant: 'red',
  },
};

export const DEFAULT_LOCALE = 'fr-fr';
